<mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="loading">
  <div class="page-container">
    <div class="page-header">
      <button mat-icon-button routerLink="/automakers">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div>
        <h2 class="page-title">Cadastrar Montadora</h2>
        <p class="page-subtitle">Preencha os dados para criar uma nova montadora</p>
      </div>
    </div>

    <div class="form-section">
      <app-automaker-form
        #automakerForm
        [states]="data.states"
        [productLines]="data.productLines"
      />
    </div>

    <div class="form-actions">
      <button mat-stroked-button color="primary" routerLink="/automakers">
        <mat-icon>close</mat-icon><span>Cancelar</span>
      </button>
      <button mat-flat-button color="primary" class="mic-btn-icon-left" [disabled]="automakerForm.form?.invalid" (click)="submitForm()">
        <mat-icon>check</mat-icon><span>Confirmar</span>
      </button>
    </div>
  </div>
</mic-spinner-overlay>